import { get, post } from "@/modules/request";
import {
  ReviewerExpenditure,
  ReviewerIncome,
  ReviewerPetition,
} from "@/types/reviewer";
import {
  CursorPageRequest,
  CursorPageResponse,
  PageRequest,
  PageResponse,
  WriteResponse,
} from "@/types/api-types";

/** 金票支出记录 */
export async function readReviewerExpenditurePage(
  request: CursorPageRequest<void>
): Promise<CursorPageResponse<ReviewerExpenditure>> {
  return get("/ReviewerExpenditure/ReadPage", request);
}

/** 金票收入记录 */
export async function readReviewerIncomePage(
  request: CursorPageRequest<void>
): Promise<CursorPageResponse<ReviewerIncome>> {
  return get("/ReviewerIncome/ReadPage", request);
}

/** 资深读者申请 */
export async function createReviewerPetition(
  text: string
): Promise<WriteResponse<ReviewerPetition>> {
  return post("/ReviewerPetition/0", { text });
}

/** 资深读者申请列表 */
export async function readReviewerPetitionPage(
  params: PageRequest<void>
): Promise<PageResponse<ReviewerPetition>> {
  return get(`/ReviewerPetition/ReadPage`, params);
}
